import { PaymentOrdersState } from 'mk2/apps/bo/containers/PaymentOrders/PaymentOrders.reducers';
import { AppState } from 'mk2/reducers';

export const getBoPaymentOrdersState = (state: AppState): PaymentOrdersState =>
    state.containers.bo.paymentOrders;
